import React from 'react';

const LoadingSpinner = ({ size = 'medium', color = '#1ca29b', fullPage = false }) => {
  const sizeMap = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-16 h-16',
  };

  const spinner = (
    <div className="flex items-center justify-center">
      <div
        className={`${sizeMap[size]} border-4 border-t-transparent rounded-full animate-spin`}
        style={{ borderColor: `${color} transparent transparent transparent` }}
      ></div>
    </div>
  );

  if (fullPage) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export const LoadingOverlay = ({ isLoading, children }) => {
  if (!isLoading) return children;

  return (
    <div className="relative">
      {children}
      <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 z-10">
        <LoadingSpinner />
      </div>
    </div>
  );
};

export const LoadingSkeleton = ({ type = 'card', count = 1 }) => {
  const skeletons = Array.from({ length: count }, (_, i) => i);

  if (type === 'card') {
    return (
      <div className="space-y-4">
        {skeletons.map((i) => (
          <div key={i} className="animate-pulse">
            <div className="bg-gray-200 h-48 rounded-lg mb-4"></div>
            <div className="space-y-3">
              <div className="bg-gray-200 h-4 rounded"></div>
              <div className="bg-gray-200 h-4 rounded w-5/6"></div>
              <div className="bg-gray-200 h-4 rounded w-4/6"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (type === 'text') {
    return (
      <div className="space-y-3 animate-pulse">
        {skeletons.map((i) => (
          <div key={i} className="space-y-2">
            <div className="bg-gray-200 h-4 rounded w-full"></div>
            <div className="bg-gray-200 h-4 rounded w-5/6"></div>
            <div className="bg-gray-200 h-4 rounded w-4/6"></div>
          </div>
        ))}
      </div>
    );
  }

  return null;
};

export default LoadingSpinner;